<template>
  <v-app id="inspire">
    <!-- Navigation Bar -->
    <app-navigation-drawer :drawer="drawer" v-if="authGuard.isAuthenticated()"></app-navigation-drawer>

    <v-content>
      <router-view @drawer="changeDrawer"></router-view>
    </v-content>
    <!-- App Footer -->
    <!-- <v-footer height="auto" class="white pa-3 mt-3" style="position:absolute;width: 100%; bottom: 0;" v-if="authGuard.isAuthenticated()">
      <span class="caption"><a href="http://cyberkingict.com/index" target="_blank"> Cyber King ICT Solutions</a> &copy; {{ new Date().getFullYear() }}</span>
      <v-spacer></v-spacer>
      <span class="caption mr-1"> Make With Love </span> <v-icon color="pink" small>favorite</v-icon>
    </v-footer>-->
  </v-app>
</template>

<script>
import NavigationDrawer from "./components/layout/NavigationDrawer";
import Login from "./components/login/Login";
import { AuthGuard } from "./helpers/auth-guard";

export default {
  data: () => ({
    authGuard: AuthGuard,
    drawer: true
  }),
  components: {
    appNavigationDrawer: NavigationDrawer,
    appLogin: Login
  },
  props: {
    source: String
  },
  methods: {
    changeDrawer: function(state) {
      this.drawer = state;
    }
  }
};
</script>
<style>
@import "assets/css/style.css";

/*.container.fluid{*/
/*margin-bottom: 40px;*/
/*}*/
</style>